import React from "react";
import { connect } from "react-redux";

import { NAV_LIST, NAV_LIST_SUB, NAV_LIST_360 } from "App/componentsConfig";
import NavItem from "./NavItem";

function Nav(props) {
  const teamPlan =
    props.plan &&
    ("" + props.plan.id)[0] === "2" &&
    props.plan &&
    props.plan.id > 199;
  return (
    <ul className="sidebar_menu_ul">
      {props.origin === "360" ||
      props.origin === "ibackup" ||
      props.origin === "idrive"
        ? NAV_LIST_360.map((page, i) => {
            if (page.key) {
              return <NavItem key={i} page={page} isFirst={props.isFirst} />;
            }
          })
        : props.ecommerceFlag === "S" || !teamPlan
        ? NAV_LIST_SUB.map((page, i) => {
            if (page.key) {
              return <NavItem key={i} page={page} isFirst={props.isFirst} />;
            }
          })
        : NAV_LIST.map((page, i) => {
            if (page.key) {
              return <NavItem key={i} page={page} isFirst={props.isFirst} />;
            }
          })}
    </ul>
  );
}

function mapStateToProps(state) {
  return {
    plan: state.account.plan,
    isFirst: state.auth.isFirst
  };
}

export default connect(mapStateToProps)(Nav);
